import type { Option } from '@/components/inputs/AutocompleteInput';
import type { DriverApi } from '@/pages/Business/pages/Drivers/models';
import { optionDataHasStringId } from './optionDataHasStringId';

export function driverAutocompleteLabel(driver: DriverApi): string {
  const fullName = `${driver.firstName} ${driver.lastName}`.trim();
  return fullName.length > 0 ? fullName : driver.id;
}

export function optionDriverIdFromOption(option: Option): string {
  if (!optionDataHasStringId(option.data)) return '';
  return option.data.id.trim();
}

function minimalDriverPlaceholder(id: string): DriverApi {
  return {
    id,
    securityId: '',
    firstName: '',
    lastName: '',
    email: '',
    status: '',
  };
}


export function driverChipOption(id: string, label: string): Option {
  return {
    label,
    data: minimalDriverPlaceholder(id),
  };
}

export function pickDriverLabelsForIds(
  ids: string[],
  labels: Record<string, string> | undefined
): Record<string, string> | undefined {
  if (!labels || ids.length === 0) return undefined;
  const out: Record<string, string> = {};
  for (const id of ids) {
    const label = labels[id];
    if (typeof label === 'string' && label.length > 0) {
      out[id] = label;
    }
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
